'use client'

import { isLegacyBrokenSafeUser } from '@/constants/legacy-broken-safes'
import { useWallet } from '@/providers/WalletContext'
import { UpgradeBrokenSafeModal } from './UpgradeBrokenSafeModal'

/**
 * Mounts the forced upgrade modal whenever the signed-in user is on the
 * LEGACY_BROKEN_SAFES allow-list. Returns null for everyone else — zero
 * runtime overhead beyond a single useWallet() read on the auth boundary.
 *
 * Lives at the root of the app so the modal hard-blocks every route until
 * the user completes the migration (or closes the tab).
 */
export function UpgradeBrokenSafeMount() {
	const { userId } = useWallet()
	if (!isLegacyBrokenSafeUser(userId)) return null
	return <UpgradeBrokenSafeModal mode="forced" open={true} />
}
